import {Component, forwardRef, Input, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgForm} from '@angular/forms';
import {ApplicantModel, KeyIdentifierModel} from '@service/models';
import {SharedkeyDataService} from '@service/services/common-services/sharedkey-data.service';
import {ApplicantType} from '@service/enum/process-state.enum';
import {FinanceService} from '@service/services/server/finance.service';
import {ApplicantService} from '@service/services';
import {UpperCasePipe} from '@angular/common';
@Component({
    selector: 'creditsnap-controlling-manager',
    templateUrl: './controlling-manager.component.html',
    styleUrls: ['./controlling-manager.component.scss'],
    providers: [UpperCasePipe,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ControllingManagerComponent),
            multi: true,
        },
    ],
})
export class ControllingManagerComponent implements ControlValueAccessor {
    @ViewChild('companyControllingManagerForm') companyControllingManagerForm: NgForm;
    @Input('data-test-id') testId: string = 'controlling-manager';
    controllingManager: ApplicantModel;
    keyIdentifier: KeyIdentifierModel;

    otherOwners: ApplicantModel[];
    companyApplicant: ApplicantModel;
    primaryApplicant: ApplicantModel;
    controllingManagerTypeArr = [];
    controllingManagerTypeValue: string;

    constructor(private sharedKeyDataService: SharedkeyDataService,
                private applicantService: ApplicantService,
                private financeService: FinanceService,
                private uppercasePipe: UpperCasePipe) {
        this.sharedKeyDataService.keyIdentifier$.subscribe(data => {
            this.keyIdentifier = data;
            this.getAllApplicantList();
        });
    }

    /**
     * Function for build Dropdown for Controlling Manager *
     */
    getAllApplicantList() {
        const controllingManagerArray = [];
        this.primaryApplicant = this.keyIdentifier.application.applicants.find(apl => apl.applicantType === ApplicantType.PRIMARY);
        let ownerName = this.primaryApplicant.firstName + ' ' + this.primaryApplicant.lastName;
        if (this.primaryApplicant.applicantId) {
            if (controllingManagerArray.indexOf(ownerName) < 0) {
                controllingManagerArray.push(this.primaryApplicant.firstName + ' ' + this.primaryApplicant.lastName);
            }
        }

        this.otherOwners = this.keyIdentifier.application.applicants.filter(item => item.applicantType === ApplicantType.OTHER);
        if (this.otherOwners.length) {
            this.otherOwners.forEach(owner => {
                ownerName = owner.firstName + ' ' + owner.lastName;
                if (controllingManagerArray.indexOf(ownerName) < 0 && owner.firstName) {
                    controllingManagerArray.push(ownerName);
                }
            });
        }

        this.companyApplicant = this.keyIdentifier.application.applicants.find(apl => apl.applicantType === 'BS') || new ApplicantModel();

        this.controllingManagerTypeArr = [];
        controllingManagerArray.forEach(item => {
            this.controllingManagerTypeArr.push({
                value: item
            });
        });

        if (!this.controllingManagerTypeValue && this.controllingManager && this.controllingManager.firstName) {
            const fullName = this.controllingManager.firstName + ' ' + this.controllingManager.lastName;
            if (this.controllingManagerTypeArr.filter(e => e.value === fullName).length <= 0) {
                this.controllingManagerTypeValue = 'SE';
            } else {
                this.controllingManagerTypeValue = this.controllingManager.firstName + ' ' + this.controllingManager.lastName;
            }
        }
    }

    /**
     * Function for Populate owners list and generate form dynamically*
     */
    updateControllingManager() {
        if (this.controllingManagerTypeValue !== 'SE') {
            // if controlling manager type is Primary applicant
            if (this.controllingManagerTypeValue === (this.primaryApplicant.firstName + ' ' + this.primaryApplicant.lastName)) {
                this.controllingManager.applicantType = ApplicantType.CONTROLLINGMANAGER;
                this.controllingManager.firstName = this.primaryApplicant.firstName;
                this.controllingManager.lastName = this.primaryApplicant.lastName;
                this.controllingManager.title = this.primaryApplicant.title;
                this.controllingManager.ssn = this.primaryApplicant.ssn;
                this.controllingManager.address = this.primaryApplicant.address;
            } else {
                // if controlling manager type is not Primary applicant select from other applicant
                if (this.otherOwners.length) {
                    this.otherOwners.forEach(owner => {
                        const ownerName = owner.firstName + ' ' + owner.lastName;
                        if (this.controllingManagerTypeValue === ownerName) {
                            this.controllingManager = owner;
                            this.controllingManager.applicantType = ApplicantType.CONTROLLINGMANAGER;
                            // set id null so it will not override Applicant type 'O' with 'CM', and it will create new entry for 'CM'
                            if (this.controllingManager || (this.controllingManager && (this.controllingManager.applicantId !== owner.applicantId))) {
                                this.controllingManager.applicantId = undefined;
                            }
                        }
                    });
                }
            }
            this.financeService.controllingManager$.next(this.controllingManager);
        } else {
            this.controllingManager = new ApplicantModel();
        }
    }

    validateAndUpdate() {
        return new Promise((resolve, reject) => {
            this.companyControllingManagerForm.form.markAllAsTouched();

            const isValid = this.companyControllingManagerForm.valid;
            if (isValid) {
                this.controllingManager.firstName = this.uppercasePipe.transform(this.controllingManager.firstName.trim());
                this.controllingManager.lastName = this.uppercasePipe.transform(this.controllingManager.lastName.trim());
                this.applicantService.addApplicant(this.keyIdentifier.applicationId, this.controllingManager).subscribe(resp => {
                    resolve(true);
                }, () => {
                    reject(false);
                });
            } else {
                reject(false);
            }
        });
    }

    registerOnChange(fn: any): void {
        console.log(fn);
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(obj: any): void {
        this.controllingManager = obj;
        this.financeService.controllingManager$.next(this.controllingManager);
    }

}
